import { useNavigate } from 'react-router-dom';

import icTicket from '@/assets/ic_ticket.svg';
import { Button, Card } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import ROUTES from '@/router/routes';

export const PrintedTickets = () => {
  const { isMobile } = useIsDesktop();
  const navigate = useNavigate();
  const handleSubmit = () => {
    if (isMobile) {
      navigate(ROUTES.virtualCharges);
    } else {
      // eslint-disable-next-line no-console
      console.log('ir a mapa en desktop');
    }
  };
  return (
    <Card
      className="bg-white border-gdt-gray-6 border-[1px] p-0 flex items-center pl-4 pr-6 h-[96px] w-full mt-4 hover:shadow-btn cursor-pointer"
      handleClick={handleSubmit}
    >
      <figure>
        <img alt="Icono de ticket impreso" src={icTicket} />
      </figure>
      <div className="ml-3 flex-1">
        <p className="text-gdt-gray-3 font-semibold text-2xs">Ticket Impreso</p>
        <strong className="block text-2xl font-bold text-gdt-gray mt-2 mb-1">
          $6.000
        </strong>
        <span className="text-3xs font-semibold text-left text-gdt-gray-4">
          5 PINES
        </span>
      </div>
      <Button className="justify-self-end" type="button" variant="secondary">
        Ver dónde
      </Button>
    </Card>
  );
};
